import React from 'react'
import { BrowserRouter as Router } from 'react-router'
import PassportRoute from './PassportRoute'

import '../shared/sass/index.scss'
import './passport.page.scss'

function PassportApp() {
  return (
    <div id="passport-ui-app-container" className="passport-root">
      <div className="passport-container">
        <div className="passport-ui">
          <div className="passport-ui-app">
            <Router>
              <PassportRoute />
            </Router>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PassportApp
